import script from "./ExportsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportsList.vue?vue&type=script&setup=true&lang=ts"

import "./ExportsList.vue?vue&type=style&index=0&id=531d6c6a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-531d6c6a"]])

export default __exports__